import moment from 'moment';
import { getLineColor } from '../../../../components/dashboards/SupplyChainSummaryProject/components/riskWidget/helper';
import { hexagon } from '../risk-history';

const config = {
  legality: {
    label: {
      en: 'Legality',
      fr: 'Légalité',
    },
    color: 'rgba(0, 192, 199, 0.5)',
  },
  humanRights: {
    label: {
      en: 'Human Rights',
      fr: 'Droits humains',
    },
    color: 'rgba(221, 98, 98, 0.5)',
  },
  environment: {
    label: {
      en: 'Environment & Natural Resources',
      fr: 'Environnement & Ressources naturelles',
    },
    color: 'rgba(144, 137, 250, 0.5)',
  },
  conflictSecurity: {
    label: {
      en: 'Conflict & Security',
      fr: 'Conflit & Sécurité',
    },
    color: 'rgba(232, 135, 26, 0.5)',
  },
  healthSafety: {
    label: {
      en: 'Health & Safety',
      fr: 'Santé et sécurité au travail',
    },
    color: 'rgba(218, 52, 144, 0.5)',
  },
  communitySociety: {
    label: {
      en: 'Community & Society',
      fr: 'Communauté & Société',
    },
    color: 'rgba(71, 226, 111, 0.5)',
  },
};

export const getLegend = (language = 'en') => {
  const all = [];
  Object.entries(config).forEach(([k, c]) => {
    all.push({ color: c.color, label: c.label[language], key: k, toggled: true });
  })
  return all;
}

export const filterData = (data = [], activeKeys = []) => {
  const all = [];
  Object.keys(config).forEach((key) => {
    if (activeKeys.includes(key)) {
      all.push(...data.filter((d) => d.type === key));
    }
  });
  return all;
};

export const getColors = (data = []) => {
  const keys = [];
  data.forEach((d) => {
    if (!keys.includes(d.type) && config[d.type]) {
      keys.push(d.type);
    }
  });
  return keys.map((k) => config[k].color);
};

export const Tooltip = (data = {}, t = (s) => s) => {
  if (data.data) {
    const { threat, impact, title, incidents } = data.data;
    const threatR = Math.round(threat);
    const threatColor = getLineColor(threatR);
    const impactR = Math.round(impact);
    const impactColor = getLineColor(impactR);

    return `
    <div class="custom-tooltip">
      <div class="tooltip-header">
        <h1>${title}</h1>
        <p class="is-link">${incidents} ${t('Incidents')}</p>
        <p>${t('Last updated on')}: ${moment(data.updatedAt).format('DD MMMM YYYY')}</p>
      </div>
      <div class="score">
        <h3>${t('Threat')}</h3>
        <div class="hexagons">
          ${[5, 4, 3, 2, 1].map((i) => threatR >= i ? hexagon(true, threatColor) : hexagon(false)).join('')}
        </div>
        <label>${threat}</label>
      </div>
      <div class="score">
        <h3>${t('Impact')}</h3>
        <div class="hexagons">
          ${[5, 4, 3, 2, 1].map((i) => impactR >= i ? hexagon(true, impactColor) : hexagon(false)).join('')}
        </div>
        <label>${impact}</label>
      </div>
    </div>
  `;
  }
};
